/* global module require */
const lib = require('./tv_base.js');

// Modules below are loaded the first time they're called, so a page only downloads what it uses.
// Callers that use `new` get a plain function, since methods can't be constructed.

// Only called where the address book block is placed, so load it then.
lib.address_book = {
    init() {
        import('../tv_address_book/address_book.ts').then(m => m.init());
    }
};
lib.artwork = require('../tv_artwork/tv_artwork.ts');
lib.cart = null;
lib.configurator = null;
lib.configurator_v2 = null;
// Called on every page.
lib.credit_application = {
    init() {
        if (document.getElementById('js_credit_application')) {
            import('../tv_credit_application/credit_application.ts').then(m => m.init());
        }
    }
};
lib.customer_orders = {
    CustomerOrderDetails: function() {
        import('../tv_customer_orders/customer_orders.ts').then(m => new m.CustomerOrderDetails());
    },
    CustomerOrderSearch: function() {
        import('../tv_customer_orders/customer_orders.ts').then(m => new m.CustomerOrderSearch());
    }
};
lib.customer_records = {
    init() {
        import('../tv_customer_records/customer_records.ts').then(m => m.init());
    },
    init_saved_designs() {
        import('../tv_customer_records/customer_records.ts').then(m => m.init_saved_designs());
    }
};
lib.designtool = null;
lib.employment_application = {
    init() {
        import('../tv_employment_application/tv_employment_application.js').then(m => m.init());
    }
};
lib.faq_schema = {
    init() {
        import('../tv_faq_schema/faq_schema.ts').then(m => m.init());
    }
};
lib.faq_section = require('../tv_utils/faq_section.ts');
lib.newsletters = {
    init() {
        import('../tv_newsletters/newsletters.ts').then(m => m.init());
    }
};
lib.order_progress_bars = {
    init() {
        import('../tv_order_progress_bars/order_progress_bars.ts').then(m => m.init());
    }
};
lib.payments = null;
lib.shipping = null;
// Called on every page.
lib.sticky_block = {
    init_sticky_block() {
        if (document.getElementsByClassName('js-sticky').length > 0) {
            import('../tv_utils/sticky_block.ts').then(m => m.init_sticky_block());
        }
    }
};
module.exports = lib;

// Overwrite CSCart's awful development js error handler that forwards you to an empty
// page with just the error message, completely devoid of context, line numbers, call stacks,
// and makes it impossible to troubleshoot on page.
window.onerror = null;
